module.exports = __webpack_public_path__ + "img/14.e83347da.jpg";